import { Col, Flex, Form, Input, Radio, Row, Select, Typography } from "antd"
import { FieldTimeOutlined } from "@ant-design/icons"

import { timeLimitOptions } from "@src/pages/paymentLinksCreate/constants"

export const PaymentLinkFormTimeLimit = () => {
  const timeLimit = Form.useWatch("timeLimit", { form: Form.useFormInstance() })
  return (
    <Flex gap={32} vertical>
      <Form.Item
        colon={false}
        id="GENERATED_ID_PAYMENTLINKFORMTIMELIMIT_TSX_FORM.ITEM_VOID_1"
        initialValue="noTimeLimit"
        label="Invoice validity time"
        layout="horizontal"
        name="timeLimit"
      >
        <Radio.Group buttonStyle="solid">
          <Radio.Button value="noTimeLimit">No time limit</Radio.Button>
          <Radio.Button value="timeLimit">Time-limited</Radio.Button>
        </Radio.Group>
      </Form.Item>

      {timeLimit === "timeLimit" && (
        <Row align="top" gutter={30}>
          <Col span={16}>
            <Form.Item
              extra={
                <Typography.Text style={{ fontSize: 12 }}>
                  Specify how long the invoice will be active
                </Typography.Text>
              }
              id="GENERATED_ID_PAYMENTLINKFORMTIMELIMIT_TSX_FORM.ITEM_VOID_2"
              label="Time"
              name="invoiceValidityTime"
              rules={[
                {
                  message: "Please input correct amount",
                  required: true,
                  validator: (_, value) => {
                    if (
                      value > 0 &&
                      value.match(/^(?!0{2,})\d+(\.\d{1,2})?$/)
                    ) {
                      return Promise.resolve()
                    }

                    return Promise.reject(
                      new Error("Please input correct amount"),
                    )
                  },
                },
              ]}
            >
              <Input placeholder="Enter time" prefix={<FieldTimeOutlined />} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              id="GENERATED_ID_PAYMENTLINKFORMTIMELIMIT_TSX_FORM.ITEM_VOID_3"
              label="Unit of time"
              name="unit"
            >
              <Select
                options={timeLimitOptions}
                placeholder="Select unit of time"
              />
            </Form.Item>
          </Col>
        </Row>
      )}
    </Flex>
  )
}
